import { defineStore } from 'pinia';
import { i18n } from '@/i18n/i18n';

const LOADING_HIDE_DELAY_MS = 200;

//Setup store
export const useFeedbackStore = defineStore('feedback', {
    state: () => ({
        isLoading: false,
        loadingCount: 0,
        loadingHideTimeout: 0 as number,
        infoMessage: '',
        successMessage: '',
        warningMessage: '',
        dangerMessage: '',
        timeouts: {
            info: 0 as number,
            success: 0 as number,
            warning: 0 as number,
            danger: 0 as number,
        },
    }),
    actions: {
        startLoading() {
            this.loadingCount++;
            if (this.loadingHideTimeout) {
                window.clearTimeout(this.loadingHideTimeout);
                this.loadingHideTimeout = 0;
            }
            this.isLoading = true;
        },

        stopLoading() {
            this.loadingCount = Math.max(0, this.loadingCount - 1);
            if (this.loadingCount > 0) {
                return;
            }
            if (this.loadingHideTimeout) {
                window.clearTimeout(this.loadingHideTimeout);
            }
            this.loadingHideTimeout = window.setTimeout(() => {
                this.loadingHideTimeout = 0;
                if (this.loadingCount === 0) {
                    this.isLoading = false;
                }
            }, LOADING_HIDE_DELAY_MS);
        },

        //Reset current message
        resetMessage() {
            //Reset all current notifications
            this.infoMessage = '';
            this.successMessage = '';
            this.warningMessage = '';
            this.dangerMessage = '';

            //Clear all current pending timeouts
            Object.values(this.timeouts).forEach(timeout => window.clearTimeout(timeout));
        },

        //Set message by text (no translation, mostly used for API response messages)
        setMessage(type: string, message: string, displayTime: number | null = null) {
            this.resetMessage();
            //Check which type of notification is requested
            switch (type) {
                case "info":
                    this.timeouts.info = window.setTimeout(() => {
                        this.infoMessage = '';
                    }, (displayTime != null ? displayTime : 3000));
                    this.infoMessage = message;
                    break;
                case "success":
                    this.timeouts.success = window.setTimeout(() => {
                        this.successMessage = '';
                    }, (displayTime != null ? displayTime : 3000));
                    this.successMessage = message;
                    break;
                case "warning":
                    this.timeouts.warning = window.setTimeout(() => {
                        this.warningMessage = '';
                    }, (displayTime != null ? displayTime : 5000));
                    this.warningMessage = message;
                    break;
                case "danger":
                    this.timeouts.danger = window.setTimeout(() => {
                        this.dangerMessage = '';
                    }, (displayTime != null ? displayTime : 10000));
                    this.dangerMessage = message;
                    break;
            }
        },

        //Set message according to type and translate with translationKey
        setTranslatedMessage(type: string, translationKey: string, displayTime: number | null = null) {
            this.resetMessage();

            //Check which type of notification is requested
            switch (type) {
                case "info":
                    this.timeouts.info = window.setTimeout(() => {
                        this.infoMessage = '';
                    }, (displayTime != null ? displayTime : 3000));
                    this.infoMessage = i18n.tm('notification.' + translationKey);
                    break;
                case "success":
                    this.timeouts.success = window.setTimeout(() => {
                        this.successMessage = '';
                    }, (displayTime != null ? displayTime : 3000));
                    this.successMessage = i18n.tm('notification.' + translationKey);
                    break;
                case "warning":
                    this.timeouts.warning = window.setTimeout(() => {
                        this.warningMessage = '';
                    }, (displayTime != null ? displayTime : 5000));
                    this.warningMessage = i18n.tm('notification.' + translationKey);
                    break;
                case "danger":
                    this.timeouts.danger = window.setTimeout(() => {
                        this.dangerMessage = '';
                    }, (displayTime != null ? displayTime : 10000));
                    this.dangerMessage = i18n.tm('notification.' + translationKey);
                    break;
            }
        },
    }
})